import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Obrigado() {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Meta Pixel tracking
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'PageView');
      if (window.location.pathname.includes('obrigado')) {
        (window as any).fbq('track', 'Lead');
      }
    }
  }, []);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const shareOnWhatsApp = () => {
    const message = encodeURIComponent(
      "🌟 Acabei de me inscrever na Seletiva Four Models em Tangará da Serra - MT! 🌟\n\n" +
      "📅 Data: 17 de Março de 2026 (Terça-feira)\n" +
      "🕐 Horário: 19h30\n" +
      "📍 Local: Hotel Íbis Tangará da Serra\n\n" +
      "A Four Models tem mais de 38 anos descobrindo talentos para moda, TV e entretenimento!\n\n" +
      "Inscreva-se também: https://tangaradaserra.fourmodelsseletivas.com.br"
    );
    window.open(`https://wa.me/?text=${message}`, '_blank', 'noopener,noreferrer');
  };

  const faqs = [
    {
      question: "O que é a Seleção de Modelos e Atores?",
      answer: "É um evento presencial onde a Four Models, agência com mais de 38 anos de experiência, avalia candidatos de 3 a 35 anos para oportunidades em moda, TV, cinema e entretenimento. Durante a seleção, você passa por avaliação profissional e recebe orientações sobre carreira artística."
    },
    {
      question: "O que acontece na Seleção?",
      answer: "O evento começa com uma palestra explicativa sobre o mercado e a metodologia Four Models. Em seguida, cada participante passa por uma avaliação individual com nossa equipe, que analisa perfil, potencial fotogênico e presença de palco. Ao final, você recebe um feedback e orientações personalizadas."
    },
    {
      question: "Como se preparar?",
      answer: "Vista-se de forma simples e confortável, com roupas que valorizem seu corpo sem exageros. Evite maquiagem pesada e acessórios chamativos. O mais importante é ser você mesmo(a) e demonstrar naturalidade e confiança. Chegue com antecedência para fazer o credenciamento tranquilamente."
    },
    {
      question: "Menor de idade precisa ir acompanhado?",
      answer: "Sim! Menores de 18 anos devem estar acompanhados de um responsável legal (pai, mãe ou tutor com documento de autorização). O responsável deve permanecer no local durante toda a seleção e assinar os documentos necessários."
    },
    {
      question: "Como devo ir à Seleção?",
      answer: "Vista roupas simples e confortáveis que valorizem seu corpo. Para mulheres: calça jeans ou legging com blusa básica. Para homens: calça jeans e camiseta. Cabelos limpos e soltos (sem bonés ou toucas). Evite roupas muito largas que escondam o corpo."
    }
  ];

  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Header */}
      <header className="bg-black border-b border-yellow-500/20 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center">
          <img 
            src="https://static.readdy.ai/image/103ec5ada18b00c7d95516c6aa3b7243/3c6853a00769ef0b898cf7c7be2b9fe6.png"
            alt="Four Models"
            className="h-16 sm:h-20 object-contain"
          />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          {/* Success Icon */}
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="absolute inset-0 bg-yellow-500/30 rounded-full animate-ping"></div>
              <div className="absolute inset-0 bg-yellow-500/20 rounded-full animate-pulse"></div>
              <div className="relative w-24 h-24 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center shadow-2xl shadow-yellow-500/50">
                <i className="ri-check-line text-5xl text-black font-bold"></i>
              </div>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center mb-4">
            <span className="text-white">Inscrição </span>
            <span className="bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
              Confirmada!
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-gray-300 text-center text-base sm:text-lg mb-12 leading-relaxed">
            Parabéns! Sua vaga está garantida. Entraremos em contato pelo WhatsApp com todos os detalhes.
          </p>

          {/* Event Details Card */}
          <div className="bg-gray-900 border-2 border-yellow-500 rounded-2xl p-6 sm:p-8 mb-8">
            <h2 className="text-yellow-500 font-bold text-xl mb-6 text-center">Detalhes do Evento</h2>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-yellow-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-line text-xl text-yellow-500"></i>
                </div>
                <div>
                  <p className="text-white font-semibold">17 de Março de 2026</p>
                  <p className="text-gray-400 text-sm">Terça-Feira</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-yellow-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-xl text-yellow-500"></i>
                </div>
                <div>
                  <p className="text-white font-semibold">19h30</p>
                  <p className="text-gray-400 text-sm">(não se atrase!)</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-yellow-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-yellow-500"></i>
                </div>
                <div>
                  <p className="text-white font-semibold">Hotel Íbis Tangará</p>
                  <p className="text-gray-400 text-sm">Tangará da Serra – MT</p>
                </div>
              </div>
            </div>
          </div>

          {/* Next Steps Card */}
          <div className="bg-gray-900 rounded-2xl p-6 sm:p-8 mb-8">
            <h2 className="text-white font-bold text-xl mb-6">Próximos Passos</h2>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-bold text-lg">1</span>
                </div>
                <p className="text-gray-300 pt-1.5">
                  Aguarde contato pelo WhatsApp com confirmação e orientações
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-bold text-lg">2</span>
                </div>
                <p className="text-gray-300 pt-1.5">
                  Compareça no dia 17/03/2026 às 19h30 no local indicado
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-black font-bold text-lg">3</span>
                </div>
                <p className="text-gray-300 pt-1.5">
                  Menores de 18 anos devem estar acompanhados de um responsável legal
                </p>
              </div>
            </div>
          </div>

          {/* Arrive Early Card */}
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-2xl p-6 sm:p-8 mb-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-alarm-line text-2xl text-black"></i>
              </div>
              <div>
                <h3 className="text-yellow-500 font-bold text-lg mb-2">Chegue com antecedência!</h3>
                <p className="text-gray-300 leading-relaxed">
                  Recomendamos chegar pelo menos 30 minutos antes do horário marcado para fazer o credenciamento tranquilamente e participar da palestra inicial sobre o mercado e a metodologia Four Models.
                </p>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="bg-gray-900 rounded-2xl p-6 sm:p-8 mb-8">
            <h2 className="text-white font-bold text-xl mb-6">Tudo que você precisa saber</h2>
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div key={index} className="border-b border-gray-800 last:border-0 pb-4 last:pb-0">
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full flex items-center justify-between gap-4 text-left cursor-pointer group"
                  >
                    <span className="text-white font-semibold group-hover:text-yellow-500 transition-colors">
                      {faq.question}
                    </span>
                    <i className={`ri-arrow-down-s-line text-2xl text-yellow-500 transition-transform flex-shrink-0 ${openFaq === index ? 'rotate-180' : ''}`}></i>
                  </button>
                  {openFaq === index && (
                    <div className="mt-4 text-gray-300 leading-relaxed">
                      {faq.answer}
                      {index === 4 && (
                        <div className="mt-4 bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4">
                          <p className="text-yellow-500 font-semibold mb-2 flex items-center gap-2">
                            <i className="ri-alert-line text-xl"></i>
                            Atenção:
                          </p>
                          <p className="text-gray-300 text-sm">
                            Evite maquiagem pesada, acessórios chamativos (brincos grandes, colares volumosos) e roupas com estampas muito chamativas. A ideia é que sua beleza natural seja o destaque!
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <button
              onClick={shareOnWhatsApp}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-xl transition-all duration-300 flex items-center justify-center gap-3 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Compartilhar com Amigos no WhatsApp
            </button>
            <button
              onClick={() => navigate('/')}
              className="w-full bg-transparent border-2 border-yellow-500 hover:bg-yellow-500 text-yellow-500 hover:text-black font-bold py-4 px-6 rounded-xl transition-all duration-300 flex items-center justify-center gap-3 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line text-xl"></i>
              Voltar para o site
            </button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-900 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-gray-600 text-center text-sm">
            © 2026 Four Models. Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
}